import React, { useContext, useEffect, useState } from 'react'
import { buildStyles, CircularProgressbar } from 'react-circular-progressbar'
import { Button, Card, CardBody, Col, Row } from 'reactstrap';
import CalendarIcon from "../images/calendar.svg";
import FinSpinner from '../commonfields/FinSpinner';
import Service from '../services';
import { OverallPercentage } from '../models/LeadModels';
import { AxiosResponse } from 'axios';
import { useLocation, useParams } from 'react-router-dom';
import { catchError } from '../utils/Utils';
import "../scss/riskSettings.scss"
import { ReactComponent as NfinityImg } from "../images/Logo_nFiniti_black.svg"
import { ReactComponent as TickIcon } from "../images/check.svg"
import ModalComponent from '../components/shared/ModalComponent';
import { ReactComponent as OrangeTick } from "../images/tickIcon.svg"
import RiskQuestionnarie from '../components/RiskQuestionnarie/RiskQuestionnarie';
import { BankUserContext } from '../bankUserContext';

const RiskSettingsDashboard = () => {
  const [loader, setLoader] = useState<boolean>(false)
  const [percentageData, setPercentageData] = useState<any>([])
  const [questionsData, setQuestionsData] = useState<any>({})
  const [headerText,setHeaderText] = useState<string>()
  const [approvedDate,setApprovedDate] = useState()
  const { clientProductId } = useParams()
  const location = useLocation();
  const [toggle, setToggle] = useState<boolean>(false)
  const service = new Service();
  const context = useContext(BankUserContext);

  const getOverallPercentage = () => {
    setLoader(true)
    service.getComplianceOverallPercentage(clientProductId).then(
      (response: AxiosResponse<OverallPercentage>) => {
        if (response.data?.status === "REVIEW_COMPLETED") {
          setPercentageData(response.data)
        } else {
          setPercentageData(response.data)
        }
      }).catch((error: any) => {
        catchError(error, true);
        setLoader(false)
      }).finally(() => {
        setLoader(false)
      });
  }

  const getQuestionsData = () => {
    setLoader(false)
    const payload = {
      "screen": "RiskSettings",
      "sections": "getRiskParameterQuestions",
      "clientProductsId": clientProductId,
      "orgId": context.bankuserDetails?.organization.orgId,
      "isJsonReturnObject": false
    }
    service
      .getQuestionsData(payload)
      .then((res: any) => {
        const data = res.data[0]?.questions && JSON.parse(res.data[0]?.questions);
        const sortedData = data && data.sort(
          (a: any, b: any) => a.sequence - b.sequence
        );
        setQuestionsData(sortedData)
        setHeaderText(res.data[0]?.header_text)
        setApprovedDate(res.data[0]?.approveddate)
        if(location.pathname.includes('merchantWelcome')){
          handleToggle()    //initially opening riskForm for merchantWelcome
        }
      })
      .catch(()=>{
        setLoader(false)
      })
      .finally(()=>{
        setLoader(false)
      })
  }

  useEffect(() => {
    getOverallPercentage()
    getQuestionsData()
  }, [])

  const RiskSettingModalHeader = () => (
    <div className="headerPart">
      <OrangeTick className="orangeTick" />
      <div className="headerText">Application Approved</div>
    </div>
  );

  const handleToggle = () => {
    setToggle((prev) => !prev)
  }

  return (
    <>
      {loader ? <FinSpinner /> : ""}
      <Row className="riskProgressWrapper">
        <Col sm="12" className="stats">
          <Card className="dasboardCard">
            <CardBody className="p-0">
              <Row>
                <Col className="overallDiv">
                  <div
                    style={{ width: 105, height: 105 }}
                    className="overallPercentage"
                  >
                    <CircularProgressbar
                      strokeWidth={14}
                      value={
                        percentageData?.overallPercentage === undefined
                          ? 0
                          : percentageData?.overallPercentage
                      }
                      text={`${percentageData?.overallPercentage === undefined
                          ? 0
                          : percentageData?.overallPercentage
                        }%`}
                      styles={buildStyles({
                        textSize: "24px",

                        pathTransitionDuration: 2.0,

                        pathColor: `rgba(0,0,0,0.2, ${percentageData?.overallPercentage / 100
                          })`,

                        textColor: "#0C2240",

                        trailColor: "rgb(235 235 235)",

                        backgroundColor: "#0C2240",
                      })}
                    />
                  </div>

                  <span className="competionText">
                    Review <br /> Completion
                  </span>
                </Col>

                <Col>
                  <img
                    src={CalendarIcon}
                    alt="CalendarIcon"
                    className="messageIcon"
                  />

                  <span className="unreadNumber">
                    {percentageData?.daysInReview}
                  </span>

                  <span className="unreadText">
                    {percentageData?.daysInReview == 1 ? "Day" : "Days"}{" "}
                    in <br /> Review
                  </span>
                </Col>
              </Row>
            </CardBody>
          </Card>
          <Col sm="12" className="detailsContainer">
            <NfinityImg className="nfinityLogo"/>
            <TickIcon className="greenTickIcon" />
            <div className="approveText">Application Approved</div>
            <div className="approveDate">{approvedDate}</div>
          </Col>
          <Col className="nextStepContainer">
            <div className="nextStepText">Next Step:</div>
            <Button className="onboardingBtn" onClick={handleToggle}>Start Onboarding</Button>
          </Col>
        </Col>
      </Row>
      <ModalComponent
        showModal={toggle}
        modalToggle={handleToggle}
        className="riskSettingModal"
        getHeaderDetails={RiskSettingModalHeader}
      >
      <RiskQuestionnarie 
        modalToggle={handleToggle}
        questionsData={questionsData}
        headerText={headerText}
        getQuestionsData={getQuestionsData}
        />
      </ModalComponent>
    </>
  )
}

export default RiskSettingsDashboard